import {HEADER_BACKGROUNDS} from '../constants/background';

const LOCAL_STORAGE_KEY = 'article_organizer_cards';
const LAST_VISITED_HERO_KEY = 'last_visited_hero';

const safeLocalStorageAction = (localStorageAction) => {
    try {
        if (global.window && localStorage && localStorageAction) {
            localStorageAction();
        }
    } catch(error) {
        // in production, we silently fail and drop the history feature
        if (process.env.NODE_ENV === 'development') {
            throw error;
        }
    }
};

/**
 * Stores in localStorage the last visited card and its index.
 * @param {string} bucketKey
 * @param {string} lastVisitedCardKey
 * @param {integer} lastVisitedCardIndex
 */
export const storeLastVisitedCard = ({bucketKey, lastVisitedCardKey, lastVisitedCardIndex}) => {
    safeLocalStorageAction(() => {
        const bucketLastVisitedKey = {
            [`${bucketKey}`]: {
                cardKey: lastVisitedCardKey,
                index: lastVisitedCardIndex,
            },
        };

        const lastVisitedCards = localStorage.getItem(LOCAL_STORAGE_KEY);
        const parsedLastVisitedCards = {
            ...JSON.parse(lastVisitedCards),
            ...bucketLastVisitedKey,
        };

        localStorage.setItem(
            LOCAL_STORAGE_KEY,
            JSON.stringify(parsedLastVisitedCards),
        );
    });
};

/**
 * Returns the last visited organizer article card stored in a certain bucket.
 * @param {string} bucketKey
 * Returns:
 * * {cardKey (string), index (integer)}
 */
export const retrieveLastVisitedCard = ({bucketKey}) => {
    let lastVisitedCards;

    safeLocalStorageAction(() => {
        lastVisitedCards = localStorage.getItem(LOCAL_STORAGE_KEY);
    });

    if (lastVisitedCards) {
        lastVisitedCards = JSON.parse(lastVisitedCards)[bucketKey];
    }

    return lastVisitedCards;
};

/**
 * Returns the last seen hero image.
 * Returns:
 * * index (integer)}
 * Note: we are calling this in the getInitialState and we need to check that the window exists
 * before calling localStorage
 */
export const getHeroImageIndex = () => {
    let heroImageIndex = -1;

    safeLocalStorageAction(() => {
        heroImageIndex = localStorage.getItem(LAST_VISITED_HERO_KEY) || 0;
    });

    return parseInt(heroImageIndex, 0);
};

/**
 * Stores the next hero image to show.
 */
export const storeHeroImageIndex = () => {
    safeLocalStorageAction(() => {
        let lastVisitedHero = getHeroImageIndex();

        if (lastVisitedHero >= 0) {
            lastVisitedHero += 1;
        }

        lastVisitedHero %= HEADER_BACKGROUNDS.length;

        localStorage.setItem(
            LAST_VISITED_HERO_KEY,
            lastVisitedHero,
        );
    });
};
